import type {Media, Image, Video} from 'src/api/local'

export type RVVideo = Video
export type RVImage = Image
export type RVMedia = Media
export type RVMedias = Media[]

export const typeIsVideo = (type: RVMedia): type is RVVideo =>
  type.__typename === 'Video'
